// SignupModal.jsx
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Box,
  IconButton,
  Alert,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import config from '../../config';

function SignupModal({ open, onClose }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailSignup = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (password !== confirmPassword) {
      setErrorMessage('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/auth/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
      if (response.ok) {
        // On successful signup, close the modal and navigate to /onboarding.
        onClose();
        navigate('/onboarding');
      } else {
        const data = await response.json();
        setErrorMessage(data.detail || 'Signup failed. Please try again.');
      }
    } catch (error) {
      console.error('Error during signup:', error);
      setErrorMessage('Error during signup. Please try again later.');
    }
    setLoading(false);
  };

  const handleGoogleSignup = () => {
    window.location.href = 'http://localhost:8000/auth/google';
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="signup-dialog-title"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle
        id="signup-dialog-title"
        sx={{ m: 0, p: 2, position: 'relative' }}
      >
        Sign Up
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {errorMessage && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}
        <Box component="form" onSubmit={handleEmailSignup} sx={{ mt: 2 }}>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            fullWidth
            margin="normal"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            label="Confirm Password"
            variant="outlined"
            type="password"
            fullWidth
            margin="normal"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Sign Up with Email'}
          </Button>
        </Box>
        <Box sx={{ textAlign: 'center', my: 2 }}>
          <span>or</span>
        </Box>
        <Button
          variant="outlined"
          fullWidth
          onClick={handleGoogleSignup}
          sx={{ mb: 2 }}
        >
          Sign Up with Google
        </Button>
      </DialogContent>
    </Dialog>
  );
}

export default SignupModal;
